<template>
  <main id="page-not-found" class="news-page">

    <!-- ── Masthead compact ───────────────────── -->
    <header class="masthead masthead--compact">
      <div class="masthead__rule masthead__rule--thick"></div>
      <div class="masthead__inner masthead__inner--row">
        <button type="button" class="not-found__back-btn" @click="$router.push({ name: 'home' })">
          ← Acasă
        </button>
      </div>
      <div class="masthead__rule masthead__rule--thin"></div>
    </header>

    <!-- ── 404 hero ──────────────────────────── -->
    <section class="not-found__hero">
      <p class="not-found__code">404</p>
      <h1 class="not-found__title">Nu am putut găsi ce cauți.</h1>
      <p class="not-found__subtitle">Pagina a dispărut, a fost mutată sau nu a existat niciodată.</p>
    </section>

    <div class="masthead__rule masthead__rule--thin not-found__divider"></div>

    <!-- ── Poll suggestion ───────────────────── -->
    <section class="not-found__suggestion">
      <p class="not-found__cta">
        Nu mai bine vrei tu să dai un vot aici?
      </p>

      <div v-if="loadingPoll" class="not-found__poll-loading">
        <div class="poll-skeleton">
          <div class="poll-skeleton__line" style="width: 70%; height: 20px; margin-bottom: 10px;"></div>
          <div class="poll-skeleton__line" style="width: 45%; height: 14px;"></div>
        </div>
      </div>

      <div v-else-if="randomPoll" class="not-found__poll-wrap">
        <PollCard :poll="randomPoll" />
      </div>

      <p v-else class="not-found__no-poll">
        Nu există sondaje disponibile momentan.
        <button type="button" class="not-found__home-btn" @click="$router.push({ name: 'home' })">
          Mergi la pagina principală
        </button>
      </p>
    </section>

  </main>
</template>

<script>
import authMixin from '../../mixins/authMixin.js';
import PollCard from '../home/partials/PollCard.vue';

export default {
  name: 'NotFound',

  components: { PollCard },

  mixins: [authMixin],

  data() {
    return {
      randomPoll: null,
      loadingPoll: false,
    };
  },

  mounted() {
    this.fetchCurrentUser();
    this.fetchRandomPoll();
  },

  methods: {
    async fetchRandomPoll() {
      this.loadingPoll = true;
      try {
        const response = await window.axios.get('polls/random-unvoted');
        this.randomPoll = response.data;
      } catch {
        this.randomPoll = null;
      } finally {
        this.loadingPoll = false;
      }
    },
  },
};
</script>
